export const ENTRY_MOVE_DRAG_MIME = 'application/x-revisdom-entry-move';

export type EntryMoveDragPayload = {
  sourceId: number;
  sourceEntryType: 'File' | 'Folder';
};

export function setEntryMoveDragData(dataTransfer: DataTransfer, payload: EntryMoveDragPayload): void {
  const json = JSON.stringify(payload);
  try {
    dataTransfer.setData(ENTRY_MOVE_DRAG_MIME, json);
  } catch {
    /* ignore */
  }
  try {
    dataTransfer.setData('text/plain', json);
  } catch {
    /* ignore */
  }
}

export function readEntryMoveDragData(dataTransfer: DataTransfer): EntryMoveDragPayload | null {
  let raw = '';
  try {
    raw = dataTransfer.getData(ENTRY_MOVE_DRAG_MIME);
  } catch {
    raw = '';
  }
  if (!raw) {
    try {
      raw = dataTransfer.getData('text/plain');
    } catch {
      raw = '';
    }
  }
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as EntryMoveDragPayload;
    if (typeof parsed?.sourceId !== 'number') return null;
    if (parsed.sourceEntryType !== 'File' && parsed.sourceEntryType !== 'Folder') return null;
    return parsed;
  } catch {
    return null;
  }
}
